import styled from 'styled-components';

export const Container = styled.div`
    .label-total
    {
        margin: 0;
        font-size: 10pt;
        font-weight: 550;
    }
`;